import Send from '@/images/Send.svg';
import { useUpdateCampaign } from '@/pages/campaign/ListPage/api';
import { CampaignAccess, ICampaign } from '@d-id/types';
import { CampaignMenuItem } from './CampaignMenuItem';
interface Props {
    campaign: ICampaign;
    closeMenu: () => void;
    onPublish: () => void;
}

export const PublishMenuItem = ({ campaign, closeMenu, onPublish }: Props) => {
    const { mutate } = useUpdateCampaign(campaign);

    if (campaign.access === CampaignAccess.PUBLIC) {
        return null;
    }

    return (
        <CampaignMenuItem
            campaign={campaign}
            closeMenu={closeMenu}
            onClick={() => {
                mutate({ access: CampaignAccess.PUBLIC });
                onPublish();
            }}
            mixPanelEvent="publish"
            icon={Send}
            text={'Publish campaign'}
        />
    );
};
